export interface Customer {
  id: string;
  name: string;
  code: string;
  email: string;
  phone: string;
  gstNumber?: string | null;
  panNumber?: string | null;
  address: string;
  city: string;
  state: string;
  pincode: string;
  contactPerson: string;
  contactPhone: string;
  creditLimit: number;
  paymentTerms: number;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

// A customer in the paged list, with what it currently owes
export interface CustomerListItem extends Customer {
  // Value of open orders that count against the credit limit
  currentOutstanding: number;
  openOrders: number;
}

export interface CreateCustomerRequest {
  name: string;
  code: string;
  email: string;
  phone: string;
  // Null (or an empty string) leaves the customer without that tax number
  gstNumber?: string | null;
  panNumber?: string | null;
  address: string;
  city: string;
  state: string;
  pincode: string;
  contactPerson: string;
  contactPhone: string;
  creditLimit?: number;
  paymentTerms?: number;
  isActive?: boolean;
}

export type UpdateCustomerRequest = Partial<CreateCustomerRequest>;

export type CustomerSortField = 'name' | 'code' | 'creditLimit' | 'createdAt';

export interface CustomerQueryParams {
  page: number;
  limit: number;
  search?: string;
  isActive?: boolean;
  credit?: 'over_limit';
  sortBy?: CustomerSortField;
  sortOrder?: 'ASC' | 'DESC';
}

export interface PaginatedCustomers {
  data: CustomerListItem[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

export interface CustomerSummary {
  total: number;
  active: number;
  inactive: number;
  // Sum of the credit limits of active customers
  totalCreditLimit: number;
  totalOutstanding: number;
  // Customers with a credit limit whose outstanding is above it
  overLimit: number;
}

// Indian states and union territories with their GST state codes
export const INDIAN_STATES: { name: string; gstCode: string }[] = [
  { name: 'Andaman and Nicobar Islands', gstCode: '35' },
  { name: 'Andhra Pradesh', gstCode: '37' },
  { name: 'Arunachal Pradesh', gstCode: '12' },
  { name: 'Assam', gstCode: '18' },
  { name: 'Bihar', gstCode: '10' },
  { name: 'Chandigarh', gstCode: '04' },
  { name: 'Chhattisgarh', gstCode: '22' },
  { name: 'Dadra and Nagar Haveli and Daman and Diu', gstCode: '26' },
  { name: 'Delhi', gstCode: '07' },
  { name: 'Goa', gstCode: '30' },
  { name: 'Gujarat', gstCode: '24' },
  { name: 'Haryana', gstCode: '06' },
  { name: 'Himachal Pradesh', gstCode: '02' },
  { name: 'Jammu and Kashmir', gstCode: '01' },
  { name: 'Jharkhand', gstCode: '20' },
  { name: 'Karnataka', gstCode: '29' },
  { name: 'Kerala', gstCode: '32' },
  { name: 'Ladakh', gstCode: '38' },
  { name: 'Lakshadweep', gstCode: '31' },
  { name: 'Madhya Pradesh', gstCode: '23' },
  { name: 'Maharashtra', gstCode: '27' },
  { name: 'Manipur', gstCode: '14' },
  { name: 'Meghalaya', gstCode: '17' },
  { name: 'Mizoram', gstCode: '15' },
  { name: 'Nagaland', gstCode: '13' },
  { name: 'Odisha', gstCode: '21' },
  { name: 'Puducherry', gstCode: '34' },
  { name: 'Punjab', gstCode: '03' },
  { name: 'Rajasthan', gstCode: '08' },
  { name: 'Sikkim', gstCode: '11' },
  { name: 'Tamil Nadu', gstCode: '33' },
  { name: 'Telangana', gstCode: '36' },
  { name: 'Tripura', gstCode: '16' },
  { name: 'Uttar Pradesh', gstCode: '09' },
  { name: 'Uttarakhand', gstCode: '05' },
  { name: 'West Bengal', gstCode: '19' },
];
